<div class="box-container">
    <div class="initials-badge">{{ initials }}</div>
    <div class="lemu_name">{{ name }}</div>
</div>
